import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first, finalize } from 'rxjs/operators';

import { AuthenticationService } from '../core/services';
import { AppState } from '../core/app-state';
import { AppConfig } from '../../environments/environment';

@Component({ templateUrl: 'login.component.html' })
export class LoginComponent implements OnInit, AfterViewInit {
    loginForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    error = '';
    env = '';

    @ViewChild('username') userNameElement: ElementRef;
    @ViewChild('password') passwordElement: ElementRef;

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private appState: AppState
    ) { 
        // redirect to home if already logged in
        if (this.authenticationService.currentUserValue) { 
            this.router.navigate(['/']);
        }
        this.env = AppConfig.environment
    }

    ngOnInit() {
        const lastUserName = this.appState.settings.getLastUserName()
        this.loginForm = this.formBuilder.group({
            username: [lastUserName, Validators.required],
            password: ['', Validators.required]
        });
        
        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }

    ngAfterViewInit() {
        if ( !this.f.username.value ) {
            this.userNameElement.nativeElement.focus()
        } else {
            this.passwordElement.nativeElement.focus()
        }
    }

    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }

    onSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }

        this.loading = true;
        this.authenticationService.login(this.f.username.value, this.f.password.value)
            .pipe(first()).pipe(finalize(()=>this.loading=false))
            .subscribe(
                data => {
                    const decodedUrl = decodeURI(this.returnUrl)
                    this.router.navigateByUrl( decodedUrl )
                },
                error => {
                    if (error.error instanceof ErrorEvent) {
                        console.error('ErrorEvent:', error);
                        this.error = error.error.message
                    } else {
                      console.error('Http response err:', error);
                      var respBody = error.error
                      if ( respBody.error ) {
                        if ( respBody.error.reason ) {
                            this.error = respBody.error.reason
                        } else {
                            this.error = 'Error: ' + error.statusText
                        }
                      } else if (error.statusText) {
                        if ( error.statusText == "Unknown Error" ) {
                            this.error = 'Server Connection Error'
                        } else {
                            this.error = error.statusText
                        }
                      } else {
                        this.error = 'Unknown Error'
                      }
                    }        
                  })
    }
}
